import memoize from "memoize-one";
import React from "react";
import { isoWebPageURL } from "tsi-common-react/src/models/nominals";

import { reverse } from "@reactivated";

import { check } from "../../../models/utils";
import { urls } from "../../../utils/urls";
import { ModularConfiguratorOptionSet } from "../models";
import { IModularConfiguratorOptionSet } from "../models.interfaces";
import { Configurator, IOwnProps as IConfiguratorProps } from "./Configurator";

interface IProps {
    optionSetJSON: string;
    passthroughProps?: Partial<IConfiguratorProps>;
}

interface IState {}

// TODO(ssr, LEVEL 3 out of 10): Migrate this component from class-style to functional-style. Rated LOE as 3/10 due to 48 LOC, memoized JSON parsing with memoize-one, simple wrapper around Configurator component, and straightforward prop passthrough pattern.
export class ModularConfigurator extends React.PureComponent<IProps, IState> {
    private readonly parseOptionSetJSON = memoize(
        (optionSetJSON: string): IModularConfiguratorOptionSet => {
            const data = check(
                ModularConfiguratorOptionSet.decode(JSON.parse(optionSetJSON)),
            );
            return data;
        },
    );

    render() {
        const optionSet = this.parseOptionSetJSON(this.props.optionSetJSON);
        return (
            <Configurator
                optionSet={optionSet}
                financingLink={
                    urls.pageURL("finance-link") || urls.pageURL("home")
                }
                basketLink={isoWebPageURL.wrap(reverse("basket:summary"))}
                favoritesLink={isoWebPageURL.wrap(reverse("basket:summary"))}
                configureGiftsLink={isoWebPageURL.wrap(
                    reverse("basket:configure-gifts"),
                )}
                {...this.props.passthroughProps}
            />
        );
    }
}
